@if (isLoggedIn) {
  <app-header></app-header>
}
@if (isLoggedIn && showtabs && tabLength > 1) {
  <app-left-navigation-menu
    class="hide-on-print"
    [items]="items ?? []"
    [userDisplayName]="userDisplayName"
    [userName]="userName"
  ></app-left-navigation-menu>
}
@if (isLoggedIn && isInitialized) {
  <main
    class="app-shell__content"
    [class.app-shell__content--with-navigation]="showtabs && tabLength > 1"
  >
    <div class="card">
      <router-outlet></router-outlet>
    </div>
  </main>
}
@if (!isLoggedIn) {
  <router-outlet></router-outlet>
}

@if (isLoggedIn) {
  <app-print-view></app-print-view>
}
@if (isLoggedIn) {
  <div class="card flex justify-content-center user-active-dialog">
    <p-dialog header="Header" [(visible)]="showInactiveDialog" [modal]="true"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '36vw' }" [draggable]="false"
      [resizable]="false" [closeOnEscape]="false" (onHide)="cancelDialog()" [blockScroll]="true">
      <ng-template pTemplate="header">
        <h2> <i class="pi pi-info-circle info-circle"></i><span>Contact Admin</span> </h2>
      </ng-template>
      <div class="flex align-items-center gap-3 mb-3">
        {{isActiveUserDialogMsg}}
      </div>
    </p-dialog>
  </div>
}